export enum StatTypes {
  daily = "daily",
  recovery = "recovery",
  mortality = "mortality",
}
